import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { parseLocalStrings } from '../../../../utils/format';
import './Fields.scss';
import { isInteger } from '../../../../utils/validation';

const validationsMapper = {
  number: (value) => isInteger(+value) && +value >= 0,
};

const defaultValidator = (value) => true;

export default function TextField({ id, label, error, ...rest }) {
  const { value = '', renderValue, tag, onChange, disabled } = rest;
  const defaultEventObj = { target: { value } };

  const validatedOnChange = (e = defaultEventObj) => {
    let {
      target: { value },
    } = e;
    value = parseLocalStrings(value);
    const validationMethod = validationsMapper?.[tag] || defaultValidator;
    const isValid = validationMethod(value);
    if (isValid) onChange(e);
    else onChange(defaultEventObj);
  };

  const color = clsx({ '#5B5B5B': disabled, white: !disabled });
  return (
    <input
      type="text"
      id={id}
      {...rest}
      style={{ ...rest?.style, color }}
      className={clsx('field-wrapper', rest?.className, { 'field-error': !!error })}
      onChange={validatedOnChange}
      value={renderValue ? renderValue(value) : value || ''}
    />
  );
}

TextField.defaultProps = {
  id: null,
  label: '',
  error: '',
};

TextField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
};
